var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{staticStyle:{"display":"inline-block"},attrs:{"headers":_vm.header,"action":_vm.uploadUrl,"on-success":_vm.handleSuccess,"before-upload":_vm.onBeforeUpload,"show-file-list":false,"data":_vm.subData}},[_c('el-button',{style:(_vm.w?'width: '+_vm.w:''),attrs:{"type":"primary","size":_vm.size}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }